import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';

const ChartContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  height: 300,
  color: '#ffffff !important',
  '.MuiTypography-root': {
    color: '#ffffff !important',
    fontWeight: 'inherit !important',
  },
  '.recharts-cartesian-grid-horizontal line, .recharts-cartesian-grid-vertical line': {
    stroke: theme.palette.mode === 'dark' ? '#2d3748' : '#e2e8f0',
  },
  '.recharts-text': {
    fill: '#ffffff !important',
    fontWeight: 'inherit !important',
  },
  '.recharts-default-tooltip': {
    backgroundColor: '#1a2035 !important',
    border: 'none',
    borderRadius: '8px',
    boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)',
    color: '#ffffff !important',
    fontWeight: 'inherit !important',
  },
  '.recharts-line': {
    stroke: 'url(#colorGradient)',
    strokeWidth: 2,
  },
  '.recharts-active-dot': {
    fill: '#3b82f6',
  }
}));

interface FinancialMetricsChartProps {
  data: Array<{
    date: string;
    value: number;
  }>;
}

export const FinancialMetricsChart: React.FC<FinancialMetricsChartProps> = ({ data }) => {
  return (
    <ChartContainer>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          data={data}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 20,
          }}
        >
          <defs>
            <linearGradient id="colorGradient" x1="0" y1="0" x2="1" y2="0">
              <stop offset="0%" stopColor="#3b82f6" />
              <stop offset="100%" stopColor="#10b981" />
            </linearGradient>
          </defs>
          <CartesianGrid 
            strokeDasharray="3 3" 
            vertical={false}
            stroke="#2d3748"
          />
          <XAxis 
            dataKey="date" 
            axisLine={false}
            tickLine={false}
          />
          <YAxis 
            axisLine={false}
            tickLine={false}
          />
          <Tooltip 
            contentStyle={{
              backgroundColor: '#1a2035',
              border: 'none',
              borderRadius: '8px',
              color: '#ffffff'
            }}
          />
          <Line
            type="monotone"
            dataKey="value"
            dot={false}
            activeDot={{ r: 6, fill: '#3b82f6' }}
            strokeWidth={2}
          />
        </LineChart>
      </ResponsiveContainer>
    </ChartContainer>
  );
}; 